import {Construtor} from './construtor';

export class IndicadorSetor implements Construtor<IndicadorSetor> {

  public idIndicadorSetor: number;
  public idIndicador: number;
  public idSetorPontoFisico: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (IndicadorSetor)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdIndicadorSetor(idIndicadorSetor: any) {
    this.idIndicadorSetor = idIndicadorSetor;
  }

  set IdSetorPontoFisico(idSetorPontoFisico: any) {
    this.idSetorPontoFisico = idSetorPontoFisico;
  }

  set IdIndicador(idIndicador: any) {
    this.idIndicador = idIndicador;
  }

  parseFromJson(indicadorSetor: any): void {
    this.idIndicadorSetor = indicadorSetor.idIndicadorSetor;
    this.idSetorPontoFisico = indicadorSetor.idSetorPontoFisico;
    this.idIndicador = indicadorSetor.idIndicador;
  }

  copyObject(indicadorSetor: IndicadorSetor): void {
    this.idIndicadorSetor = indicadorSetor.idIndicadorSetor;
    this.idSetorPontoFisico = indicadorSetor.idSetorPontoFisico;
    this.idIndicador = indicadorSetor.idIndicador;
  }

  modeloCompleto(): boolean {
    return this.idSetorPontoFisico !== undefined && this.idIndicador !== undefined;
  }

  getNewInstance(object?: any): IndicadorSetor {
    return new IndicadorSetor(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/indicador-setor.ts